/**
 * Safe rendering for FTS5 `snippet()` output. `snippet()` wraps matches in
 * whatever delimiter text you give it but does **not** escape the rest of
 * the content — and that content comes from files the user imported, which
 * could contain literal HTML. `searchService` therefore asks FTS5 for
 * plain sentinel characters (not `<mark>` tags) as delimiters; this module
 * escapes the whole string for HTML first, then substitutes the sentinels
 * for real tags, so anything from the source document is neutralized before
 * any markup is (re)introduced.
 */
export const SNIPPET_MARK_OPEN = "";
export const SNIPPET_MARK_CLOSE = "";

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/** Escapes a raw snippet for safe `dangerouslySetInnerHTML` use, then turns
 * the sentinel markers into `<mark>` tags. */
export function renderSnippetHtml(snippet: string): string {
  return escapeHtml(snippet).split(SNIPPET_MARK_OPEN).join("<mark>").split(SNIPPET_MARK_CLOSE).join("</mark>");
}

/** Plain-text variant — strips the sentinels instead of turning them into
 * markup, for contexts (like the command palette) that render as text. */
export function stripSnippetMarkers(snippet: string): string {
  return snippet.split(SNIPPET_MARK_OPEN).join("").split(SNIPPET_MARK_CLOSE).join("");
}
